module.exports = __webpack_public_path__ + "img/logo.ed66ea5c.png";